import React from "react";
import { connect } from "react-redux";
import {
  editarEmpresa,
  guardarEmpresa,
} from "../../components/empresas/EmpresaService";
import { obtenerIdEmpresa, esSesionAdmin } from "../usuario/Usuario";
import {
  getPlantillas,
  guardarPlantilla
} from "../../components/correo/CorreoService";

import PantallaCarga from "../mensajeFlash/PantallaCarga";
import Quill from "quill";
import "quill/dist/quill.snow.css"; // Estilos predeterminados de Quill

import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from '../mensajeFlash/MensajeFlash';

class PlantillaCorreo extends React.Component {

  constructor(props) {
    super(props);

    const plantilla = this.props.location.state?.plantilla;

    this.state = {
      idPlantilla: 0,
      tipoEventos: [],
      tipoEvento: plantilla ? plantilla.id : "",
      wildcards: [],
      responderA: "",
      asunto: "",
      cuerpo: "<p></p>",
      plantillas: [],
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "neutral",
      error: false,
      cargando: true,
      plantilla,
      nombrePlantilla: plantilla ? plantilla.nombre : "Sin nombre"
    };
    this.editorRef = React.createRef();
  }

  componentDidMount() {
    const empresa = esSesionAdmin() ? -200 : obtenerIdEmpresa();
    // Inicializar Quill
    this.quill = new Quill(this.editorRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "link"],
          [{ list: "ordered" }, { list: "bullet" }],
        ],
      },
    });

    // Establecer contenido inicial
    this.quill.root.innerHTML = this.state.cuerpo;

    // Manejar cambios en el contenido
    this.quill.on("text-change", () => {
      this.setState({ cuerpo: this.quill.root.innerHTML });
    });

    getPlantillas(empresa).then(response => {
      if (!response.error) {
        const plantillaEncontrada = response.datos.find(p => p.tipoId === this.props.location.state?.plantilla.id);
        if (plantillaEncontrada) {
          this.setState({
            idPlantilla: plantillaEncontrada.id,
            wildcards: plantillaEncontrada.wildcards,
            responderA: plantillaEncontrada.responderA,
            asunto: plantillaEncontrada.asunto,
            cuerpo: plantillaEncontrada.cuerpo,
            cargando: false
          });
          this.quill.root.innerHTML = plantillaEncontrada.cuerpo;
        }
      } else {
        this.setState({
          mensajeFlash: response.mensaje,
          mensajeFlashSeverity: "danger"
        });
      }
    });

  }

  guardar = () => {
    this.setState({ openPantallaCarga: true });
    const json = {
      id: this.state.idPlantilla,
      tipoId: this.state.tipoEvento,
      responderA: this.state.responderA,
      asunto: this.state.asunto,
      empresaId: obtenerIdEmpresa(),
      cuerpo: this.state.cuerpo
    };

    guardarPlantilla(json).then(response => {
      this.props.history.push({
        pathname: `/configuracion/plantilla-correo`,
        state: {
          mensajeFlash: response.mensaje,
          mostrarMensajeFlash: true,
          mensajeFlashSeverity: response.error ? "error" : "exito",
        }
      });
    });
  }


  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  render() {

    const { nombrePlantilla } = this.state;

    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl='/configuracion/plantilla-correo'
                breadcrumbs={
                  [
                    { label: 'Configuraciones', path: '' },
                    { label: 'Plantilla de correos', path: '/configuracion/plantilla-correo' },
                    { label: 'Editar plantilla', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">{nombrePlantilla}</h1>
                  <p className="page-description">Editar plantilla de correo para el evento {nombrePlantilla}</p>
                </div>
                <div className="head-actions">
                  <button className="btn-medium btn-primary" onClick={this.guardar}> GUARDAR </button>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">
              <div className="component-configurar-correo">
                <div className="page-container">
                  <div className="card">
                    <div className="grid-30-70">
                      <div className="config-area">

                        <div className="form-group">
                          <input type="email" name="responderA" className="form-input" onChange={this.handleChange} value={this.state.responderA} />
                          <label htmlFor="email" className="form-label"> Responde a </label>
                        </div>
                        <div className="form-group">
                          <input type="text" name="asunto" className="form-input" onChange={this.handleChange} value={this.state.asunto} />
                          <label htmlFor="text" className="form-label"> Asunto </label>
                        </div>
                        {
                          this.state.plantilla.wildcards.length > 0 &&

                          <div>
                            <p className="form-description"> Estos son los posibles parámetros a incluir en el cuerpo del mensaje: </p>

                            <div className="content-inner">
                              <span className="label"> Copie y peque estos parámetros en el área de texto </span>
                              <div className="row__labels">
                                {this.state.plantilla.wildcards.map((elemento) =>
                                  <span key={elemento.id} className="label__accent"> {elemento} </span>
                                )}

                              </div>
                            </div>
                          </div>
                        }

                      </div>

                      <div className="component-rich-text">
                        <div ref={this.editorRef}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>
        </div>
      </div>

    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  guardarEmpresa: (value) => dispatch(guardarEmpresa(value)),
  editarEmpresa: (value) => dispatch(editarEmpresa(value)),
});

export default connect(null, mapDispatchToProps)(PlantillaCorreo);
